import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import loadingSpinner from './assets/loading.gif';
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { isBenby } from "./components/Security";
import Sidebar from './components/Menu/Sidebar';
import Topbar from './components/Menu/Topbar';
import Home from './components/Home';
import TimeKeeping from './components/TimeKeeping/TimeKeeping';
import TamperedApproval from './components/TimeKeeping/TamperedApproval';
import Payroll from './components/Payroll/Payroll';
import ThirteenthMonth from './components/Payroll/ThirteenthMonth';
import FinalPay from './components/Payroll/FinalPay';
import Subcon from './components/Payroll/Subcon';
import Agency from './components/Payroll/Agency';
import PayType from './components/Maintenance/PayType';
import Holiday from './components/Maintenance/Holiday';
import HolidayType from './components/Maintenance/HolidayType';
// import Tax from './components/GovernmentPremiums/Tax';
import Tax from './components/GovernmentPremiums/TaxNew';
import Pagibig from './components/GovernmentPremiums/Pagibig';
import SSS from './components/GovernmentPremiums/SSS';
// import Philhealth from './components/GovernmentPremiums/Philhealth';
import Philhealth from './components/GovernmentPremiums/PhilhealthNew';
import Ecola from './components/Maintenance/Ecola';
import Department from './components/Maintenance/Department';
import Section from './components/Maintenance/Section';
import Classification from './components/Maintenance/Classification';
import Client from './components/Maintenance/Client';
import PayrollPeriod from './components/Payroll/PayrollPeriod';
import SSSAdjustmentDate from './components/Maintenance/SSSAdjustmentDate';
import Company from './components/Maintenance/Company';
import DTRCorrectionWorkers from './components/Transaction/DTRCorrectionWorkers';
import DTRAdminView from './components/Transaction/DTRAdminView';
import DTREmployeeView from './components/Transaction/DTREmployeeView';
import MobileDTRApproval from './components/Transaction/MobileDTRApproval';
import DTRWithOTViewing from './components/Transaction/DTRWithOTViewing';
import ApproverHierarchy from './components/Transaction/ApproverHierarchy';
import ApproverHierarchyPerLocation from './components/Transaction/ApproverHierarchyPerLocation';
import RequestApproval from './components/Transaction/RequestApproval';
import RequestApprovalTimeKeeper from './components/Transaction/RequestApprovalTimeKeeper';
import MassApproval from './components/Transaction/MassApproval';
import Overtime from './components/Transaction/Overtime';
import DTRCorrection from './components/Transaction/DTRCorrection';
import Leave from './components/Transaction/Leave';
import ChangeOfSchedule from './components/Transaction/ChangeOfSchedule';
import LeaveTypes from './components/Maintenance/LeaveTypes';
import Benefits from './components/LoansBenefits/Benefits';
import Loans from './components/LoansBenefits/Loans';
import AddEmployee from './components/Personnel/AddEmployee';
import EmployeeInformation from './components/Personnel/EmployeeInformation';
import EmployeesList from './components/Personnel/EmployeesList';
import EmployementStatus from './components/Personnel/EmployementStatus';
import OnBoarding from './components/Personnel/OnBoarding';
import OutBoarding from './components/Personnel/OutBoarding';
import OnBoardingPersonnel from './components/Personnel/OnBoardingPersonnel';
import EmployeeMonthlySalary from './components/SalaryModule/EmployeeMonthlySalary';
import EmployeeDailySalary from './components/SalaryModule/EmployeeDailySalary';
import QuotaBasedSalary from './components/SalaryModule/QuotaBasedSalary';
import PositionDesignationSalary from './components/SalaryModule/PositionDesignationSalary';
import EmployeeSchedule from './components/Personnel/EmployeeSchedule';
import EmployeeReliever from './components/Personnel/EmployeeReliever';
import EmployeeBankAccount from './components/SalaryModule/EmployeeBankAccount';
import Position from './components/Maintenance/Position';
import JobTitle from './components/Maintenance/JobTitle';
import EmployeeGroup1 from './components/Maintenance/EmployeeGroup1';
import EmployeeGroup2 from './components/Maintenance/EmployeeGroup2';
import EmployeeStatus from './components/Maintenance/EmployeeStatus';
import Location from './components/Maintenance/Location';
import DTRRulesConfiguration from './components/Maintenance/DTRRulesConfiguration';
import TimeKeeper from './components/Maintenance/TimeKeeper';
import Plantilya from './components/Maintenance/Plantilya';
import CostCenter from './components/Maintenance/CostCenter';
import PayrollJournalAccount from './components/Maintenance/PayrollJournalAccount';
import OnBoardingRequirements from './components/Maintenance/OnBoardingRequirements';
import OutBoardingRequirements from './components/Maintenance/OutBoardingRequirements';
// import Announcement from './components/Maintenance/Announcement';
import ShiftSchedule from './components/TimeKeeping/ShiftSchedule';
import Payslip from './components/Reports/Payslip';
import PayrollRegister from './components/Reports/PayrollRegister';
// import PayrollHistory from './components/Reports/PayrollHistory';
import Resigned from './components/Reports/Resigned';
import ActiveEmployees from './components/Reports/ActiveEmployees';
import YearOfService from './components/Reports/YearOfService';
import SSSReport from './components/Reports/SSSReport';
import PagibigReport from './components/Reports/PagibigReport';
import PhilhealthReport from './components/Reports/PhilhealthReport';
import SSSLoanReport from './components/Reports/SSSLoanReport';
import PagibigLoanReport from './components/Reports/PagibigLoanReport';
import Report201 from './components/Reports/Report201';
import Users from './components/Users';
import SSSLoan from './components/LoansBenefits/SSSLoan';
import Settings from './components/Settings';
import Calendar from './components/Calendar';
import LoginForm from './components/LoginForm';
import SSSCalamityLoan from './components/LoansBenefits/SSSCalamityLoan';
import PagibigLoan from './components/LoansBenefits/PagibigLoan';
import PagibigCalamityLoan from './components/LoansBenefits/PagibigCalamityLoan';
import CashAdvance from './components/LoansBenefits/CashAdvance';
import Deductions from './components/LoansBenefits/Deductions';
import AttendanceReport from './components/Reports/AttendanceReport';
import BankTransmittalBPI from './components/Reports/BankTransmittalBPI';
import BankTransmittalBDO from './components/Reports/BankTransmittalBDO';
import BankTransmittalChinaBank from './components/Reports/BankTransmittalChinaBank';
import BankTransmittalHSBC from './components/Reports/BankTransmittalHSBC';
import BankTransmittalSecurityBank from './components/Reports/BankTransmittalSecurityBank';
import SummaryOfTardiness from './components/Reports/SummaryOfTardiness';
import AbsencesMemo from './components/Reports/AbsencesMemo';
import AbsencesReport from './components/Reports/AbsencesReport';
import ActionHistoryReport from './components/Reports/ActionHistoryReport';
import AllowanceSummary from './components/Reports/AllowanceSummary';
import AuditTrailReportEmployeeSetup from './components/Reports/AuditTrailReportEmployeeSetup';
import BundyClockUsage from './components/Reports/BundyClockUsage';
import BasicPayAdjustmentReport from './components/Reports/BasicPayAdjustmentReport';
import CertificateOfEmployment from './components/Reports/CertificateOfEmployment';
import CertificateOfPagibig from './components/Reports/CertificateOfPagibig';
import CertificateOfPhilhealth from './components/Reports/CertificateOfPhilhealth';
import CertificateOfSSS from './components/Reports/CertificateOfSSS';
import CommissionsSummary from './components/Reports/CommissionsSummary';
import CostCenterReport from './components/Reports/CostCenterReport';
import DeductionsPerMonth from './components/Reports/DeductionsPerMonth';
import DTRReport from './components/Reports/DTRReport';
import EarningsPerMonth from './components/Reports/EarningsPerMonth';
import EmployeeLeaveGroup from './components/Reports/EmployeeLeaveGroup';
import EmployeeOvertimeGroup from './components/Reports/EmployeeOvertimeGroup';
import EmployeeExpenseGroup from './components/Reports/EmployeeExpenseGroup';
import EmployeeLeaveHistory from './components/Reports/EmployeeLeaveHistory';
import EmployeeListingByHiringDate from './components/Reports/EmployeeListingByHiringDate';
import EmployeeRegister from './components/Reports/EmployeeRegister';
import ExpenseReport from './components/Reports/ExpenseReport';
import PerDayTracker from './components/Reports/PerDayTracker';
import OvertimeSummaryReport from './components/Reports/OvertimeSummaryReport';
import TrackerReport from './components/Reports/TrackerReport';
import GovernmentEmployeeInventory from './components/Reports/GovernmentEmployeeInventory';
import HeadcountReport from './components/Reports/HeadcountReport';
import HolidayPremiumSummary from './components/Reports/HolidayPremiumSummary';
import LeaveLedgerReport from './components/Reports/LeaveLedgerReport';
import LeaveSummaryReport from './components/Reports/LeaveSummaryReport';
import LoanHistory from './components/Reports/LoanHistory';
import LoanPaymentsSummary from './components/Reports/LoanPaymentsSummary';
import LoansMonthlyAmmortizationSummary from './components/Reports/LoansMonthlyAmmortizationSummary';
import LoansPenaltyHistory from './components/Reports/LoansPenaltyHistory';
import NightDifferentialSummary from './components/Reports/NightDifferentialSummary';
import NonTaxableAllowancesReport from './components/Reports/NonTaxableAllowancesReport';
import OtherEarningsReport from './components/Reports/OtherEarningsReport';
import OtherDeductionsSummary from './components/Reports/OtherDeductionsSummary';
import OutstandingLoans from './components/Reports/OutstandingLoans';
import PayrollCashRegister from './components/Reports/PayrollCashRegister';
import PayrollCheckRegister from './components/Reports/PayrollCheckRegister';
import PayrollDebitMemo from './components/Reports/PayrollDebitMemo';
import PayrollJournalByCostCenter from './components/Reports/PayrollJournalByCostCenter';
import PayrollJournalByDepartment from './components/Reports/PayrollJournalByDepartment';
import PayrollJournalBySummary from './components/Reports/PayrollJournalBySummary';
import PayrollPerPaymentMethod from './components/Reports/PayrollPerPaymentMethod';
import SelectLogs from './components/Reports/SelectLogs';
import SummaryReportByMonthAndDepartment from './components/Reports/SummaryReportByMonthAndDepartment';
import TardinessMemo from './components/Reports/TardinessMemo';
import TimeKeepingHistoryDetailedReport from './components/Reports/TimeKeepingHistoryDetailedReport';
import TimeKeepingHoursWorkedReport from './components/Reports/TimeKeepingHoursWorkedReport';
import TimeKeepingHoursWorkedSummary from './components/Reports/TimeKeepingHoursWorkedSummary';
import TimesheetStatusReport from './components/Reports/TimesheetStatusReport';
import YTDDeductionSummary from './components/Reports/YTDDeductionSummary';
import YTDEarningsSummary from './components/Reports/YTDEarningsSummary';
import YTDPayrollRegister from './components/Reports/YTDPayrollRegister';
import BIR2316 from './components/Reports/BIR2316';
import BIR1601C from './components/Reports/BIR1601C';
import Alphalist from './components/Reports/Alphalist';
import LoanReport from './components/Reports/LoanReport';
import BankTransmittalReport from './components/Reports/BankTransmittalReport';
import SubscriptionExpiredPage from './SubscriptionExpiredPage';
import OffsetCredits from './components/Transaction/OffsetCredits';
import OffsetRequest from './components/Transaction/OffsetRequest';


// import WebSocketComponent from './components/WebSocket';

function App() {
  const subcribed = true;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState([]);
  const [userAccess, setUserAccess] = useState([]);
  const [employeePhoto, setEmployeePhoto] = useState(null);

  const [isHideSideMenu, setIsHideSideMenu] = useState(false);

  console.log({user})
  // console.log({domain})

  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpiration');
  // localStorage.removeItem('user');
  // localStorage.removeItem('isLoggedIn');
  // localStorage.removeItem('userAccess');

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn');
    if (loggedIn === 'true') {
      setIsLoggedIn(true);
    }
    setIsLoading(false);
    
    
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
        setUser(storedUser);
        try {
          setUser(JSON.parse(storedUser));
        } catch (error) {
          console.error('Error parsing userAccess:', error);
          setUser([]);
        }
    }

    const storedUserAccess = localStorage.getItem('userAccess');
    if (storedUserAccess) {
      try {
        setUserAccess(JSON.parse(storedUserAccess));
      } catch (error) {
        console.error('Error parsing userAccess:', error);
        setUserAccess([]);
      }
    }
  }, []);

  const handleLogin = (user, userAccess) => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', true);

    setUser(user);
    localStorage.setItem('user', JSON.stringify(user));

    setUserAccess(userAccess)
    localStorage.setItem('userAccess', JSON.stringify(userAccess));
  };

  const handleLogout = useCallback(async () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');

    localStorage.removeItem('user');
    localStorage.removeItem('userAccess');
    setUser([]);
    setUserAccess([]);

    window.location.pathname = "/";
  }, []);

  useEffect(() => {
    if(!isLoggedIn) return;
    
    let idleTimer;

    const handleUserIdle = () => {
      handleLogout();
    };

    const resetIdleTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(handleUserIdle, userAccess?.userTimeOut ? userAccess?.userTimeOut * 60000 : 2 * 60000);
    };

    window.addEventListener('mousemove', resetIdleTimer);
    window.addEventListener('keypress', resetIdleTimer);
    window.addEventListener('touchstart', resetIdleTimer);

    resetIdleTimer();

    return () => {
      window.removeEventListener('mousemove', resetIdleTimer);
      window.removeEventListener('keypress', resetIdleTimer);
      window.removeEventListener('touchstart', resetIdleTimer);
      clearTimeout(idleTimer);
    };
  }, [handleLogout, isLoggedIn, userAccess]);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
          <img src={loadingSpinner} alt="Loading..." />
      </div>
      )
  }

  return (
    <>
      {/* <WebSocketComponent /> */}
      <BrowserRouter>
        <div className="App">
          { subcribed ?
            <>
              {!isLoggedIn ? (
                <>
                  {/* {resetDomainRootId()} */}
                  <LoginForm handleLogin={handleLogin} />
                </>
              ) : (
                <>
                  <div className="sidebar-content">
                    <Sidebar user={user} userAccess = {userAccess} isHideSideMenu={isHideSideMenu} setIsHideSideMenu={setIsHideSideMenu}/>
                  </div>
                  <div className="topbar-content">
                    <Topbar handleLogout={handleLogout} 
                        user={user} 
                        userAccess={userAccess} 
                        employeePhoto={employeePhoto} setEmployeePhoto={setEmployeePhoto} 
                        isHideSideMenu={isHideSideMenu}
                      />
                    </div>
                    <div className="content">
                        <Routes>
                          <Route path="/" element={<Home user={user} userAccess = {userAccess} employeePhoto={employeePhoto} setEmployeePhoto={setEmployeePhoto} isHideSideMenu={isHideSideMenu}/>} />
                          { userAccess?.hasAddEmployee ? 
                            (
                              <Route path="/addEmployee" element={<AddEmployee user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.description === "Employee" ? 
                            (
                              <Route path="/employeeInformation" element={<EmployeeInformation user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeeList ? 
                            (
                                <Route path="/employeesList" element={<EmployeesList user={user} userAccess={userAccess} employeePhoto={employeePhoto} setEmployeePhoto={setEmployeePhoto} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeereliever ? 
                            (
                                <Route path="/employeeReliever" element={<EmployeeReliever user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          
                          { userAccess?.hasEmploymentStatus ? 
                            (
                              <Route path="/employmentStatus" element={<EmployementStatus user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeeSchedule ? 
                            (
                              <Route path="/employeeSchedule" element={<EmployeeSchedule user={user} userAccess = {userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOnBoarding ? 
                            (
                              <Route path="/onBoarding" element={<OnBoarding user={user} userAccess = {userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOutBoarding ? 
                            (
                              <Route path="/outBoarding" element={<OutBoarding user={user} userAccess = {userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOnBoardingPersonnel ? 
                            (
                              <Route path="/onBoardingPersonnel" element={<OnBoardingPersonnel user={user} userAccess = {userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasTimeEntries ? 
                            (
                                <Route path="/timeKeeping" element={<TimeKeeping user={user} userAccess = {userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasTamperedApproval ? 
                            (
                              
                              <Route path="/tamperedApproval" element={<TamperedApproval user={user} userAccess = {userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasShiftSchedule ? 
                            (
                              <Route path="/shiftSchedule" element={<ShiftSchedule user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasProcessPayroll ? 
                            (
                                <Route path="/payroll" element={<Payroll user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.has13thMonth ? 
                            (
                                <Route path="/thirteenthMonth" element={<ThirteenthMonth user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasFinalPay ? 
                            (
                                <Route path="/finalPay" element={<FinalPay user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasSubcon ? 
                            (
                                <Route path="/subcon" element={<Subcon user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasAgency ? 
                            (
                                <Route path="/agency" element={<Agency user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPayrollPeriod ? 
                            (
                              <Route path="/payrollPeriod" element={<PayrollPeriod user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPayType ? 
                            (
                              <Route path="/payType" element={<PayType user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasHoliday ? 
                            (
                              <Route path="/holiday" element={<Holiday user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasHolidayType ? 
                            (
                              <Route path="/holidayType" element={<HolidayType user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasLeaveType ? 
                            (
                              <Route path="/leaveTypes" element={<LeaveTypes user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasDepartment ? 
                            (
                              <Route path="/department" element={<Department user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasSection ? 
                            (
                              <Route path="/section" element={<Section user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasClassification ? 
                            (
                              <Route path="/classification" element={<Classification user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasClient ? 
                            (
                              <Route path="/client" element={<Client user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasCompany ? 
                            (
                              <Route path="/company" element={<Company user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPosition ? 
                            (
                              <Route path="/position" element={<Position user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasJobTitle ? 
                            (
                                <Route path="/jobTitle" element={<JobTitle user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeeGroup1 ? 
                            (
                                <Route path="/employeeGroup1" element={<EmployeeGroup1 user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeeGroup2 ? 
                            (
                                <Route path="/employeeGroup2" element={<EmployeeGroup2 user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeeStatus ? 
                            (
                                <Route path="/employeeStatus" element={<EmployeeStatus user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasLocation ? 
                            (
                                <Route path="/location" element={<Location user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasDTRRulesConfiguration ? 
                            (
                                <Route path="/dtrRulesConfiguration" element={<DTRRulesConfiguration user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasTimeKeeper ? 
                            (
                                <Route path="/timeKeeper" element={<TimeKeeper user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPlantilya ? 
                            (
                                <Route path="/plantilya" element={<Plantilya user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasCostCenter ? 
                            (
                                <Route path="/costCenter" element={<CostCenter user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPayrollJournalAccount ? 
                            (
                                <Route path="/payrollJournalAccount" element={<PayrollJournalAccount user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOnBoardingRequirements ? 
                            (
                                <Route path="/onBoardingRequirements" element={<OnBoardingRequirements user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOutBoardingRequirements ? 
                            (
                                <Route path="/outBoardingRequirements" element={<OutBoardingRequirements user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeeMonthlySalary ? 
                            (
                              <Route path="/employeeMonthlySalary" element={<EmployeeMonthlySalary user={user} userAccess = {userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeeDailySalary ? 
                            (
                              <Route path="/employeeDailySalary" element={<EmployeeDailySalary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasQuotaBasedSalary ? 
                          // { true ? 
                            (
                              <Route path="/quotaBasedSalary" element={<QuotaBasedSalary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPositionDesignationSalary ? 
                            (
                              <Route path="/positionDesignationSalary" element={<PositionDesignationSalary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasEmployeeBankAccount ? 
                            (
                              <Route path="/employeeBankAccount" element={<EmployeeBankAccount user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasBIRTax ? 
                            (
                              <Route path="/tax" element={<Tax user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPagibig ? 
                            (
                              <Route path="/pagibig" element={<Pagibig user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasSSS ? 
                            (
                              <Route path="/sss" element={<SSS user={user} isHideSideMenu={isHideSideMenu} />}/>
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPhilhealth ? 
                            (
                              <Route path="/philhealth" element={<Philhealth user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasDTR ? 
                            (
                              <Route path="/dtr" element={<DTRAdminView user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasDTRBiometrics ? 
                            (
                              <Route path="/dtrBiometrics" element={<DTREmployeeView user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasMobileDTRApproval ? 
                            (
                              <Route path="/mobileDTRApproval" element={<MobileDTRApproval user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasDTRWithOTViewing ? 
                            (
                              <Route path="/dtrWithOTViewing" element={<DTRWithOTViewing user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasApproverHierarchy ? 
                            (
                                <Route path="/approverHierarchy" element={<ApproverHierarchy isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasApproverheirarchyperlocation ? 
                            (
                                <Route path="/approverHierarchyPerLocation" element={<ApproverHierarchyPerLocation isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasRequestApproval ? 
                            (
                              <Route path="/requestApproval" element={<RequestApproval user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasRequestApprovalTimeKeeper ? 
                            (
                              <Route path="/requestApprovalTimeKeeper" element={<RequestApprovalTimeKeeper user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasMassapproval ?
                            (
                              <Route path="/massApproval" element={<MassApproval user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasDTRCorrectionWorkers ?
                            (
                              <Route path="/dtrCorrectionWorkers" element={<DTRCorrectionWorkers user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOvertime ? 
                            (
                              <Route path="/overtime" element={<Overtime user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasDTRCorrection ? 
                            (
                              <Route path="/dtrCorrection" element={<DTRCorrection user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasLeave ? 
                            (
                              <Route path="/leave" element={<Leave user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasChangeOfSchedule ? 
                            (
                              <Route path="/changeOfSchedule" element={<ChangeOfSchedule user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOffsetCredits ? 
                            (
                              <Route path="/offsetCredits" element={<OffsetCredits user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOffsetRequest ? 
                            (
                              <Route path="/offsetRequest" element={<OffsetRequest user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasSSSLoan ? 
                            (
                              <Route path="/sssLoan" element={<SSSLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasSSSCalamityLoan ? 
                            (
                              <Route path="/sssCalamityLoan" element={<SSSCalamityLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPagibigLoan ? 
                            (
                              <Route path="/pagibigLoan" element={<PagibigLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPagibigLoan ? 
                            (
                              <Route path="/pagibigLoan" element={<PagibigLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasPagibigCalamityLoan ? 
                            (
                              <Route path="/pagibigCalamityLoan" element={<PagibigCalamityLoan user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasCashAdvance ? 
                            (
                                <Route path="/cashAdvance" element={<CashAdvance user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasLoans ? 
                            (
                                <Route path="/loans" element={<Loans user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasDeductions ? 
                            (
                              <Route path="/deductions" element={<Deductions user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasBenefits ? 
                            (
                              <Route path="/benefits" element={<Benefits user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          {userAccess?.hasPerDayTracker ? (
                            <Route path="/perDayTracker" element={<PerDayTracker isHideSideMenu={isHideSideMenu}/>} />
                          )
                            :
                            (<></>)
                          }
                          {userAccess?.hasOvertimeSummaryReport ? (
                              <Route path="/overtimeSummaryReport" element={<OvertimeSummaryReport isHideSideMenu={isHideSideMenu}/>} />
                          )
                            :
                            (<></>)
                          }
                          {userAccess?.hasTrackerReport ? (
                              <Route path="/trackerReport" element={<TrackerReport isHideSideMenu={isHideSideMenu}/>} />
                          )
                            :
                            (<></>)
                          }
                          {userAccess?.hasPayslip ? (
                            <Route path="/payslip" element={<Payslip isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }
                          {userAccess?.hasPayrollRegister ? (
                            <Route path="/payrollRegister" element={<PayrollRegister user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasResigned ? (
                            <Route path="/resigned" element={<Resigned user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasActiveEmployees ? (
                            <Route path="/activeEmployees" element={<ActiveEmployees user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasYearofService ? (
                            <Route path="/yearOfService" element={<YearOfService user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasSSSSummary ? (
                            <Route path="/sss-report" element={<SSSReport user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasPagibigSummary ? (
                            <Route path="/pagibig-report" element={<PagibigReport user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasPhilhealthSummary ? (
                            <Route path="/philhealth-report" element={<PhilhealthReport user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasSSSLoanReport ? (
                            <Route path="/sssLoan-report" element={<SSSLoanReport isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasPagibigLoanReport ? (
                            <Route path="/pagibigLoan-report" element={<PagibigLoanReport isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.has201Report ? (
                            <Route path="/201report" element={<Report201 isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasAttendanceReport ? (
                            <Route path="/attendanceReport" element={<AttendanceReport user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasBankTransmittalBPI ? (
                            <Route path="/bankTransmittalBPI" element={<BankTransmittalBPI isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasBankTransmittalBDO ? (
                            <Route path="/bankTransmittalBDO" element={<BankTransmittalBDO isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasBankTransmittalChinaBankSavings ? (
                            <Route path="/bankTransmittalChinaBankSavings" element={<BankTransmittalChinaBank isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasBankTransmittalHSBC ? (
                            <Route path="/bankTransmittalHSBC" element={<BankTransmittalHSBC isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasBankTransmittalSecurityBank ? (
                            <Route path="/bankTransmittalSecurityBank" element={<BankTransmittalSecurityBank isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasSummaryOfTardiness ? (
                            <Route path="/summaryOfTardiness" element={<SummaryOfTardiness user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasAbsencesMemo ? (
                            <Route path="/absencesMemo" element={<AbsencesMemo user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasAbsencesReport ? (
                            <Route path="/absencesReport" element={<AbsencesReport user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasActionHistoryReport ? (
                            <Route path="/actionHistoryReport" element={<ActionHistoryReport user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasAllowanceSummary ? (
                            <Route path="/allowanceSummary" element={<AllowanceSummary user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasAuditTrailReportEmployeeSetup ? (
                            <Route path="/auditTrailReportEmployeeSetup" element={<AuditTrailReportEmployeeSetup user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasBasicPayAdjustmentReport ? (
                            <Route path="/basicPayAdjustmentReport" element={<BasicPayAdjustmentReport user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasBundyClockUsage ? (
                            <Route path="/bundyClockUsage" element={<BundyClockUsage isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasCertificateOfEmployment ? (
                            <Route path="/certificateOfEmployment" element={<CertificateOfEmployment user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasCertificateOfPagibig ? (
                            <Route path="/certificateOfPagibig" element={<CertificateOfPagibig user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasCertificateOfPhilhealth ? (
                            <Route path="/certificateOfPhilhealth" element={<CertificateOfPhilhealth user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }

                          {userAccess?.hasCertificateOfSSS ? (
                            <Route path="/certificateOfSSS" element={<CertificateOfSSS user={user} isHideSideMenu={isHideSideMenu} />} />
                          )
                            :
                            (<></>)
                          }
                          { userAccess?.hasCommissionsSummary ? 
                            (
                              <Route path="/commissionsSummary" element={<CommissionsSummary isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasCostCenterReport ? 
                            (
                              <Route path="/costCenterReport" element={<CostCenterReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasDeductionsPerMonth ? 
                            (
                              <Route path="/deductionsPerMonth" element={<DeductionsPerMonth user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasDTRReport ? 
                            (
                              <Route path="/dtrReport" element={<DTRReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasEarningsPerMonth ? 
                            (
                              <Route path="/earningsPerMonth" element={<EarningsPerMonth user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasEmployeeLeaveGroup ? 
                            (
                              <Route path="/employeeLeaveGroup" element={<EmployeeLeaveGroup user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasEmployeeOvertimeGroup ? 
                            (
                              <Route path="/employeeOvertimeGroup" element={<EmployeeOvertimeGroup user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasEmployeeExpenseGroup ? 
                            (
                              <Route path="/employeeExpenseGroup" element={<EmployeeExpenseGroup isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasEmployeeLeaveHistory ? 
                            (
                              <Route path="/employeeLeaveHistory" element={<EmployeeLeaveHistory user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasEmployeeListingByHiringDate ? 
                            (
                              <Route path="/employeeListingByHiringDate" element={<EmployeeListingByHiringDate user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasEmployeeRegister ? 
                            (
                              <Route path="/employeeRegister" element={<EmployeeRegister user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasExpenseReport ? 
                            (
                              <Route path="/expenseReport" element={<ExpenseReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasGovernmentEmployeeInventory ? 
                            (
                              <Route path="/governmentEmployeeInventory" element={<GovernmentEmployeeInventory isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasHeadcountReport ? 
                            (
                              <Route path="/headcountReport" element={<HeadcountReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasHolidayPremiumSummary ? 
                            (
                              <Route path="/holidayPremiumSummary" element={<HolidayPremiumSummary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasLeaveLedgerReport ? 
                            (
                              <Route path="/leaveLedgerReport" element={<LeaveLedgerReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasLeaveSummaryReport ? 
                            (
                              <Route path="/leaveSummaryReport" element={<LeaveSummaryReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasLoanHistory ? 
                            (
                              <Route path="/loanHistory" element={<LoanHistory user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasLoanPaymentsSummary ? 
                            (
                              <Route path="/loanPaymentsSummary" element={<LoanPaymentsSummary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasLoansMonthlyAmortizationSummary ? 
                            (
                              <Route path="/loansMonthlyAmmortizationSummary" element={<LoansMonthlyAmmortizationSummary isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasLoansPenaltyHistory ? 
                            (
                              <Route path="/loansPenaltyHistory" element={<LoansPenaltyHistory isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasNightDifferentialSummary ? 
                            (
                              <Route path="/nightDifferentialSummary" element={<NightDifferentialSummary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasNonTaxableAllowancesReport ? 
                            (
                              <Route path="/nonTaxableAllowancesReport" element={<NonTaxableAllowancesReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasOtherEarningsReport ? 
                            (
                              <Route path="/otherEarningsReport" element={<OtherEarningsReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasOtherDeductionsSummary ? 
                            (
                              <Route path="/otherDeductionsSummary" element={<OtherDeductionsSummary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasOutstandingLoans ? 
                            (
                              <Route path="/outstandingLoans" element={<OutstandingLoans isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasPayrollCashRegister ? 
                            (
                              <Route path="/payrollCashRegister" element={<PayrollCashRegister user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasPayrollCheckRegister ? 
                            (
                              <Route path="/payrollCheckRegister" element={<PayrollCheckRegister user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasPayrollDebitMemo ? 
                            (
                              <Route path="/payrollDebitMemo" element={<PayrollDebitMemo isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasPayrollJournalByCostCenter ? 
                            (
                              <Route path="/payrollJournalByCostCenter" element={<PayrollJournalByCostCenter user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasPayrollJournalByDepartment ? 
                            (
                              <Route path="/payrollJournalByDepartment" element={<PayrollJournalByDepartment user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasPayrollJournalBySummary ? 
                            (
                              <Route path="/payrollJournalBySummary" element={<PayrollJournalBySummary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasPayrollPerPaymentMethod ? 
                            (
                              <Route path="/payrollPerPaymentMethod" element={<PayrollPerPaymentMethod isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasSelectLogs ? 
                            (
                              <Route path="/selectLogs" element={<SelectLogs user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasSummaryReportByMonthAndDepartment ? 
                            (
                              <Route path="/summaryReportByMonthAndDepartment" element={<SummaryReportByMonthAndDepartment isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasTardinessMemo ? 
                            (
                              <Route path="/tardinessMemo" element={<TardinessMemo user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasTimeKeepingHistoryDetailedReport ? 
                            (
                              <Route path="/timeKeepingHistoryDetailedReport" element={<TimeKeepingHistoryDetailedReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasTimeKeepingHoursWorkedReport ? 
                            (
                              <Route path="/timeKeepingHoursWorkedReport" element={<TimeKeepingHoursWorkedReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasTimeKeepingHoursWorkedSummary ? 
                            (
                              <Route path="/timeKeepingHoursWorkedSummary" element={<TimeKeepingHoursWorkedSummary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasTimesheetStatusReport ? 
                            (
                              <Route path="/timesheetStatusReport" element={<TimesheetStatusReport isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasYTDDeductionSummary ? 
                            (
                              <Route path="/ytdDeductionSummary" element={<YTDDeductionSummary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasYTDEarningsSummary ? 
                            (
                              <Route path="/ytdEarningsSummary" element={<YTDEarningsSummary user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasYTDPayrollRegister ? 
                            (
                              <Route path="/ytdPayrollRegister" element={<YTDPayrollRegister user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasBIR2316 ? 
                            (
                              <Route path="/BIR2316" element={<BIR2316 isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasBIR1601C ? 
                            (
                              <Route path="/BIR1601C" element={<BIR1601C isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasAlphaList ? 
                            (
                              <Route path="/alphalist" element={<Alphalist user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasLoanReport ? 
                            (
                              <Route path="/loanReport" element={<LoanReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasBankTransmittalReport ? 
                            (
                              <Route path="/bankTransmittalReport" element={<BankTransmittalReport user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }

                          { userAccess?.hasUser ? 
                            (
                              <Route path="/users" element={<Users user={user} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasSettings ? 
                            (
                              <Route path="/settings" element={<Settings isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasCalendar ? 
                            (
                              <Route path="/calendar" element={<Calendar user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>} />
                            )
                            :
                            (<></>)
                          }
                          { userAccess?.hasMaintenance ? 
                            (
                              <>
                                <Route path="/ecola" element={<Ecola isHideSideMenu={isHideSideMenu}/>} />
                                <Route path="/sssAdjustmentDate" element={<SSSAdjustmentDate isHideSideMenu={isHideSideMenu}/>} />
                              </>
                            )
                            :
                            (<></>)
                          }
                        </Routes>
                    </div>
                </>
              )}
            </>
            :
            <>
              <SubscriptionExpiredPage />
            </>
          }
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;